<ng-container [ngSwitch]="language$ | async" class="ion-padding">
  <app-scorp-cgv-en *ngSwitchCase="'en'"></app-scorp-cgv-en>
  <app-scorp-cgv-fr *ngSwitchCase="'fr'"></app-scorp-cgv-fr>
</ng-container>
